module.exports = __webpack_public_path__ + "img/9788958076667.cf306f6b.jpg";